// extracted by mini-css-extract-plugin
module.exports = {"image":"card-media-image_image__PUuGO","square":"card-media-image_square__KI_If","wide":"card-media-image_wide__rrwq_"};